import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var DeclaracionComponent = /** @class */ (function () {
    function DeclaracionComponent(_formService, fb) {
        this._formService = _formService;
        this.fb = fb;
        this.rows = [];
        this.form = new FormGroup({
            plano: new FormControl(''),
            denominado: new FormControl(''),
            elaborado: new FormControl(''),
            profesion: new FormControl(''),
        });
        if (!JSON.parse(localStorage.getItem("declaracion"))) {
            localStorage.setItem("declaracion", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("declaracion"));
            this.form.controls['plano'].setValue(this.rows[0] ? this.rows[0].plano : 'NO');
            this.form.controls['denominado'].setValue(this.rows[0] ? this.rows[0].denominado : '');
            this.form.controls['elaborado'].setValue(this.rows[0] ? this.rows[0].elaborado : '');
            this.form.controls['profesion'].setValue(this.rows[0] ? this.rows[0].profesion : '');
        }
        this.declaracion = { plano: '', denominado: '', elaborado: '', profesion: '' };
    }
    DeclaracionComponent.prototype.add_declaracion = function () {
        //var checkDeclaracion = event.value;
        localStorage.setItem("declaracion", JSON.stringify([]));
        this.actualRow = localStorage.getItem("declaracion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            plano: this.form.value.plano,
            denominado: this.form.value.denominado,
            elaborado: this.form.value.elaborado,
            profesion: this.form.value.profesion
        });
        localStorage.setItem("declaracion", JSON.stringify(this.rows));
        console.log(this.declaracion);
    };
    DeclaracionComponent.prototype.delete_declaracion = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("declaracion", JSON.stringify(this.rows));
            }
        }
    };
    return DeclaracionComponent;
}());
export { DeclaracionComponent };
